const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const getPerformanceSummary = (history, configuredInitialValue = null) => {
  const points = Array.isArray(history)
    ? history
        .map((row) => ({
          date: row?.date,
          value: toNumber(row?.net_usdt),
        }))
        .filter((row) => row.value !== null)
    : [];

  if (!points.length) {
    return {
      initialValue: null,
      currentValue: null,
      changeValue: null,
      changePercent: null,
      pointCount: 0,
    };
  }

    const initialValue = toNumber(configuredInitialValue) ?? points[0].value;
  const currentValue = points[points.length - 1].value;
  const changeValue = currentValue - initialValue;
  const changePercent = initialValue !== 0 ? (changeValue / initialValue) * 100 : null;

  return {
    initialValue,
    currentValue,
    changeValue,
    changePercent,
    pointCount: points.length,
  };
};

export const formatUsdt = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';

  return `${n.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })} USDT`;
};

export const formatPercent = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';

  return `${n.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })}%`;
};
